const wavelengthToColor = (wl: number): string => {
    let r: number, g: number, b: number, alpha: number;

    if (wl >= 390 && wl < 440) {
        r = (-1 * (wl - 440)) / (440 - 390);
        g = 0;
        b = 1;
    } else if (wl >= 440 && wl < 490) {
        r = 0;
        g = (wl - 440) / (490 - 440);
        b = 1;
    } else if (wl >= 490 && wl < 510) {
        r = 0;
        g = 1;
        b = (-1 * (wl - 510)) / (510 - 490);
    } else if (wl >= 510 && wl < 580) {
        r = (wl - 510) / (580 - 510);
        g = 1;
        b = 0;
    } else if (wl >= 580 && wl < 645) {
        r = 1;
        g = (-1 * (wl - 645)) / (645 - 580);
        b = 0.0;
    } else if (wl >= 645 && wl <= 750) {
        r = 1;
        g = 0;
        b = 0;
    } else if (wl < 390) {
        // UV: extend as faint violet, fading with distance from visible
        r = 1;
        g = 0;
        b = 1;
    } else {
        // IR: extend as faint red, fading with distance from visible
        r = 1;
        g = 0;
        b = 0;
    }

    // intensity is lower at the edges of the visible spectrum.
    if (wl < 390) {
        alpha = 0.05 + 0.25 * ((wl - 200) / (390 - 200));
    } else if (wl > 750) {
        alpha = 0.05 + 0.25 * (1 - (wl - 750) / 300);
    } else if (wl > 700) {
        // fade red from full opacity at 700nm down to 0.30 at 750nm
        alpha = 1 - 0.7 * ((wl - 700) / 50);
    } else if (wl < 420) {
        // (wl - 380) / (420 - 380);
        alpha = 1;
    } else {
        alpha = 1;
    }

    return 'rgba(' + r * 100 + '%,' + g * 100 + '%,' + b * 100 + '%, ' + alpha + ')';
};

export default wavelengthToColor;
